import type { JSX } from 'react';
import { dateTileParts } from './date-tile.js';

/**
 * Weekday, day, and start time. Decorative when the same time is already in
 * nearby text (the timing strip). Otherwise the tile is an image with a name,
 * and the glyphs inside it are hidden so the name is read once.
 */
export function DateTile({
  startInstant,
  venueTimeZone,
  decorative,
}: {
  startInstant: string;
  venueTimeZone: string;
  decorative: boolean;
}): JSX.Element {
  const parts = dateTileParts(startInstant, venueTimeZone);
  const glyphs = (
    <>
      <span className="date-tile__dow" aria-hidden="true">
        {parts.weekday}
      </span>
      <span className="date-tile__dom" aria-hidden="true">
        {parts.day}
      </span>
      <span className="date-tile__time" aria-hidden="true">
        {parts.time}
      </span>
    </>
  );
  if (decorative) {
    return (
      <div className="date-tile" aria-hidden="true">
        {glyphs}
      </div>
    );
  }
  return (
    <div className="date-tile" role="img" aria-label={parts.accessibleName}>
      {glyphs}
    </div>
  );
}
